// extracted by mini-css-extract-plugin
export default {"badgeContainer":"history_entry_profiles_accordion-module___badgeContainer___b8492050","profiles":"history_entry_profiles_accordion-module___profiles___adba1696"};